<template>
	<div>
		<PageHeader
			:data="{
				name: 'Deliveries Import',
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Deliveries', to: '/deliveries' },
				],
			}"
		/>

		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<LPDataImporter :tableName="'deliveries'" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import LPDataImporter from '@/components/lp-data-importer/LPDataImporter'
export default {
	name: 'DeliveriesImport',
	components: { PageHeader, LPDataImporter },
	data() {
		return {}
	},
	computed: {
		...mapState(['authUser']),
	},
}
</script>
